<template>
  <div>
    <v-layout row wrap class="mt-2">
      <v-flex xs12 sm12 style="display: flex;">
        <!-- <div style="width: 25%">
          <VueDatePicker
            v-model="selectedDate"
            @input="onSearch"
            :range-presets="presets"
            placeholder="Début - Fin"
            range="fullscreen-mobile"
            validate
          />
        </div> -->
        <div style="width: 100%">
          <InputSearch
            class="mb-3"
            :search="search"
            @clickSearch="
              onSearch()
              isSearch = true
            "
            @clearSearch="
              clearSearch()
              isSearch = false
            "
            :isSearch="isSearch"
            :placeholder="'ค้นหา ชื่อบัญชี, อีเมล, เบอร์โทร'"
            showAdvancedSearch
            @clickAdvancedSearch="showAdvance = !showAdvance"
          />
        </div>
      </v-flex>
    </v-layout>

    <v-layout wrap>
      <v-flex xs12 sm4>
        <!-- <h3 class="title">{{ $t('Customer') }}</h3> -->
        <Typography h2 bold :label="$t('Customer')" />
      </v-flex>
      <v-flex xs12 sm8 class="text-xs-right">
        <template v-if="loading">
          <!-- <v-btn outline loading color="grey"></v-btn> -->
          <v-btn outline loading color="grey"></v-btn>
        </template>
        <template v-else>
          <!-- <template v-if="$store.getters.getPackage != 'premium' ">
            <v-btn color="grey" outline>
              <i class="fas fa-file-import"></i>
              &nbsp;
              {{ $t('Import') }}&nbsp;
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
            <v-btn color="grey" outline>
              <i class="fas fa-file-export"></i>
              &nbsp;
              {{ $t('export') }}&nbsp;
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
          </template> -->
          <template>
            <!-- <template>
              <v-btn color="grey" outline>
                <countdown :time="computedImportDelay * 1000" @end="onCountdownEnd">
                  <template slot-scope="props">
                    <template v-if="props.minutes > 0">
                      {{ props.minutes }}
                      <span class="small">{{ $t('Minutes') }}</span>
                    </template>
                    <template v-else>
                      {{ props.seconds }}
                      <span class="small">{{ $t('Seconds') }}</span>
                    </template>
                  </template>
                </countdown>
              </v-btn>
            </template> -->
            <!-- <template v-else>
              <v-btn color="grey" outline @click="importCustomer">
                <i class="fas fa-file-import"></i>
                &nbsp;
                {{ $t('Import') }}
              </v-btn>
            </template> -->
            <!-- <v-btn
              style="margin-right: 6px!important;"
              color="grey"
              outline
              @click="onExportCustomer('info')"
            >
              <i class="fas fa-file-export" />
              &nbsp;
              {{ $t('export') }}
            </v-btn> -->
            <v-btn
              variant="outlined"
              @click="onExportCustomer('info')"
              :loading="loading"
              icon
              color="#BECCDB"
              style="border-radius: 50% !important"
              :disabled="isError"
            >
              <img
                src="/static/img/exportfilter.png"
                alt
                class="responsive-img"
                style="height: 16px"
              />
            </v-btn>

            <!-- <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="grey"
                  dark
                  v-on="on"
                  style="display: inline-block; border-radius: 0; margin-left: -10px"
                  outline
                  icon
                >
                  <v-icon>arrow_drop_down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile @click="onExportCustomer('dataSummary')">
                  <v-list-tile-title>{{ $t('Export all data summary') }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu> -->
          </template>
        </template>

        <!-- <v-btn dark depressed color="primary" @click="showAdvance = !showAdvance">
          <v-icon>search</v-icon>
          &nbsp;
          {{ $t('advanced search') }}&nbsp;
          <i class="fas fa-angle-down" v-if="!showAdvance"></i>
          <i class="fas fa-angle-up" v-else></i>
        </v-btn> -->
      </v-flex>
    </v-layout>
    <!-- <div
      v-if="showAdvance"
      class="mb-4"
      style="border: 1px solid #eee; border-radius: 10px; position: relative"
    > -->
    <v-dialog v-model="showAdvance" width="500px" persistent>
      <v-card style="border-radius: 10px">
        <v-btn style="float: right" @click="showAdvance = false" icon><v-icon>close</v-icon></v-btn>
        <!-- <template> -->
        <!-- <v-premium-plan-popup
          :showAll="false"
          marginTop="65"
          v-if="$store.getters.getPackage != 'premium'"
          style="border-radius: 10px"
        ></v-premium-plan-popup> -->
        <filter-customer :total_user="total_user" v-model="filter" class="pa-4">
          <!-- <v-btn outline color="grey" @click="clearSearch">{{ $t('Clear Search') }}</v-btn>
            <v-btn depressed @click="onSearch" color="primary">
              <i class="fas fa-search mr-1"></i>
              {{ $t('Search') }}
            </v-btn> -->
          <div class="pt-2" style="display: flex; justify-content: center">
            <Button
              outline
              :label="$t('Clear Search')"
              @click="
                clearSearch()
                isSearch = false
              "
            />
            <Button
              depressed
              :label="$t('Search')"
              @click="
                onSearch()
                isSearch = true
              "
            />
          </div>
        </filter-customer>
        <!-- </template> -->
      </v-card>
    </v-dialog>
    <!-- </div> -->
    <!-- <v-pagination
      :total-visible="15"
      v-model="pageNumber"
      @input="changePage"
      :length="pagelength"
    ></v-pagination> -->

    <v-data-table
      :loading="loading"
      :headers="filteredHeader"
      :items="users"
      class="elevation-1"
      v-bind:pagination.sync="pagination"
      hide-actions
    >
      <template v-slot:items="props">
        <customer-item v-model="props.item"></customer-item>
      </template>

      <div class="text-xs-center" slot="no-data">{{ $t('No customer') }}</div>
    </v-data-table>

    <v-layout row wrap class="mt-3">
      <v-flex xs6></v-flex>
      <v-flex xs6>
        <div style="display: flex;justify-content: end;align-items: center;">
          <!-- <span class="caption mr-2">{{ $t('Total') }}</span> -->
          <Typography h5 bold :label="$t('Total')" class="mr-1" />

          <span :style="`font-size: 19px;color:${$vuetify.theme.primary};font-weight: 600`">{{
            total_user | numberFormat
          }}</span>
        </div>
      </v-flex>
    </v-layout>

    <div>
      <Paginations
        @clickPagination="changepage"
        @sortPage="sortPage"
        :pageCount="pageCount"
        :numberPage="numberPage"
        :page="page"
      />
    </div>

    <v-dialog v-model="showExport" persistent max-width="800" scrollable>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab flat small @click="showExport = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text style="max-height: 600px">
          <v-layout wrap>
            <template v-for="page in exportpagecount">
              <v-flex xs6 sm4 md3 :key="`expor_${page}`" class="pa-2">
                <div class="z-border-red text-xs-center py-3">
                  <v-icon x-large>folder_shared</v-icon>
                  <div class="caption">
                    {{ ((page - 1) * exportlimit + 1) | numberFormat }} -
                    <template v-if="page == exportpagecount">
                      {{ total_user | numberFormat }}
                    </template>
                    <template v-else>{{ (page * exportlimit) | numberFormat }}</template>
                  </div>
                  <v-btn
                    small
                    color="primary"
                    depressed
                    @click="
                      exportType === 'info'
                        ? exportCustomer((page - 1) * exportlimit)
                        : exportDataSummary((page - 1) * exportlimit)
                    "
                    >download</v-btn
                  >
                </div>
              </v-flex>
            </template>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Customers from './Customers.js'
export default {
  mixins: [Customers]
}
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/Customers.vue